<template>
  <div class="user">
    <!-- 搜索区域保持不变 -->
    <div class="common-seach-wrap">
      <el-form
        :inline="true"
        size="small"
        :model="formInline"
        class="demo-form-inline"
      >
        <el-form-item label="简历名称">
          <el-input
            placeholder="请输入简历名称"
            v-model="formInline.search"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button
        size="small"
        icon="el-icon-plus"
        type="primary"
        @click="addClick"
        >添加简历</el-button
      >
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table
            size="small"
            :data="tableData"
            border
            style="width: 100%"
            v-loading="loading"
            :row-style="{ height: '40px' }"
            :cell-style="{ padding: '0 8px' }"
          >
            <!-- 原有列保持不变 -->
            <el-table-column
              prop="user.nickName"
              label="用户"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="jobInfo.name"
              label="岗位"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="school.name"
              label="学校"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="age"
              label="年龄"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="work_exp"
              label="工作经验"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="degree"
              label="学历"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="working_status"
              label="在职状态"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="expect_salary"
              label="期待薪资"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="expect_city"
              label="期待城市"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="job_info_exp"
              label="岗位经验"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="work_history"
              label="工作经历"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="school_history"
              label="入学经历"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="sort"
              label="排序"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              prop="create_time"
              label="创建时间"
              width="150"
              show-overflow-tooltip
            ></el-table-column>

            <!-- 新增审核状态列 -->
            <el-table-column label="审核状态" width="120" show-overflow-tooltip>
              <template slot-scope="scope">
                <el-tag
                  :type="getStatusTagType(scope.row.is_status)"
                  size="small"
                >
                  {{ getStatusText(scope.row.is_status) }}
                </el-tag>
              </template>
            </el-table-column>

            <!-- 操作列增加审核按钮 -->
            <el-table-column fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <!-- 审核按钮（仅当状态为0未审核时显示） -->
                <el-button
                  v-if="scope.row.is_status === 0"
                  @click="auditClick(scope.row, 1)"
                  type="text"
                  size="small"
                  style="color: #67C23A;"
                >
                  通过
                </el-button>
                <el-button
                  v-if="scope.row.is_status === 0"
                  @click="auditClick(scope.row, 2)"
                  type="text"
                  size="small"
                  style="color: #F56C6C;"
                >
                  拒绝
                </el-button>
                <el-button
                  @click="editClick(scope.row)"
                  type="text"
                  size="small"
                  >编辑</el-button
                >
                <el-button
                  @click="deleteClick(scope.row)"
                  type="text"
                  size="small"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
    <Edit
      :open_add="open_edit"
      :resume_id="resume_id"
      v-if="open_edit"
      @close="closeEdit"
    ></Edit>
  </div>
</template>

<script>
import ResumeApi from "@/api/resume.js";
import Add from "./part/add.vue";
import Edit from "./part/edit.vue";

export default {
  components: {
    Add,
    Edit
  },
  data() {
    return {
      loading: true,
      tableData: [],
      pageSize: 20,
      totalDataNumber: 0,
      curPage: 1,
      form: {},
      formInline: {
        search: ""
      },
      open_add: false,
      open_edit: false,
      resume_id: ""
    };
  },
  created() {
    this.getTableList();
  },
  methods: {
    // 获取审核状态对应的文本
    getStatusText(status) {
      const statusMap = {
        0: "未审核",
        1: "已通过",
        2: "已拒绝"
      };
      return statusMap[status] || "未知状态";
    },

    // 获取审核状态对应的标签类型
    getStatusTagType(status) {
      const typeMap = {
        0: "warning",
        1: "success",
        2: "danger"
      };
      return typeMap[status] || "";
    },

    // 审核操作
    auditClick(row, status) {
      const actionText = status === 1 ? "通过" : "拒绝";
      this.$confirm(`确定要${actionText}该简历吗?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          ResumeApi.auditResume({
            resume_id: row.resume_id,
            status: status
          })
            .then(res => {
              if (res.code === 1) {
                this.$message.success(`简历${actionText}成功`);
                this.getTableList();
              } else {
                this.$message.error(res.msg || `简历${actionText}失败`);
              }
            })
            .catch(() => {
              this.$message.error("操作失败");
            });
        })
        .catch(() => {
          this.$message.info("已取消操作");
        });
    },

    // 其他原有方法保持不变
    closeAdd(e) {
      this.open_add = false;
      this.getTableList();
    },
    closeEdit(e) {
      this.open_edit = false;
      this.getTableList();
    },
    getData() {
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },
    getTableList() {
      let self = this;
      let Params = this.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      self.loading = true;
      ResumeApi.list(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {
          self.loading = false;
        });
    },
    addClick() {
      this.open_add = true;
    },
    editClick(row) {
      this.resume_id = row.resume_id;
      this.open_edit = true;
    },
    deleteClick(row) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          ResumeApi.del({ resume_id: row.resume_id }, true).then(data => {
            if (data.code == 1) {
              this.$message.success("删除成功");
              this.getTableList();
            } else {
              this.$message.error(data.msg || "删除失败");
            }
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style scoped>
/* 固定表格行高和滚动样式 */
.table-wrap {
  overflow: auto;
  max-height: 60vh; /* 根据需要调整这个高度值 */
}

.table-wrap >>> .el-table {
  table-layout: fixed;
}

.table-wrap >>> .el-table .el-table__body-wrapper {
  overflow: auto;
}

.table-wrap >>> .el-table th,
.table-wrap >>> .el-table td {
  height: 40px;
  line-height: 40px;
}

.table-wrap >>> .el-table .cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/* 保持原有的标签样式 */
.el-tag--success {
  background-color: #f0f9eb;
  border-color: #e1f3d8;
  color: #67c23a;
}
.el-tag--warning {
  background-color: #fdf6ec;
  border-color: #faecd8;
  color: #e6a23c;
}
.el-tag--danger {
  background-color: #fef0f0;
  border-color: #fde2e2;
  color: #f56c6c;
}

/* 分页样式调整 */
.pagination {
  margin-top: 20px;
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/resume/index/index.vue